import { Phone, Clock, CheckCircle, Shield, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

// New van image - White Volkswagen ID.Buzz on Parisian street
const VAN_IMAGE = "https://customer-assets-lxgj4vgw.emergentagent.net/job_wellness-pro-68/artifacts/epnhgbd8_63489B9C-F400-4AEC-8BA0-EDAF113685CF.png";

export default function HeroBanner({ 
  title, 
  subtitle, 
  highlightText = "Fichet",
  showFeatures = true,
  showCTA = true,
  config,
  breadcrumb = null,
  variant = "default" // default, compact, full
}) {
  const isCompact = variant === "compact";
  
  return (
    <section 
      className="relative bg-[#0f2744] overflow-hidden"
      data-testid="hero-banner"
    >
      {/* Background image with overlay - clip to show only top part with van */}
      <div className="absolute inset-0">
        <img 
          src={VAN_IMAGE}
          alt="Fichet Dépannage - Service de serrurerie"
          className="w-full h-full object-cover"
          style={{ objectPosition: 'top center', objectFit: 'cover' }}
        />
        {/* Strong gradient overlay from left to ensure text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f2744] via-[#0f2744]/85 to-[#0f2744]/30"></div>
      </div>

      {/* Content */}
      <div className={`container-custom relative z-10 ${isCompact ? 'py-12 md:py-16' : 'py-16 md:py-24'}`}>
        {/* Breadcrumb */}
        {breadcrumb && (
          <div className="mb-4">
            {breadcrumb}
          </div>
        )}

        <div className="max-w-2xl">
          {/* Tag line */}
          <div className="flex items-center gap-2 text-orange-400 text-sm font-semibold mb-4">
            <span className="w-8 h-px bg-orange-400"></span>
            SERRURERIE FICHET DEPUIS PLUS DE 10 ANS
          </div>

          {/* Title */}
          <h1 className={`font-bold text-white mb-4 leading-tight ${isCompact ? 'text-3xl md:text-4xl' : 'text-4xl md:text-5xl lg:text-6xl'}`}>
            {title.split(highlightText).map((part, i, arr) => (
              <span key={i}>
                {part}
                {i < arr.length - 1 && <span className="text-orange-400">{highlightText}</span>}
              </span>
            ))}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p className={`text-gray-300 mb-6 ${isCompact ? 'text-base' : 'text-lg md:text-xl'}`}>
              {subtitle}
            </p>
          )}

          {/* Features */}
          {showFeatures && !isCompact && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Clock className="w-5 h-5 text-orange-400" />
                <div>
                  <div className="font-semibold text-white">INTERVENTION RAPIDE</div>
                  <div className="text-xs">EN 30 MIN EN MOYENNE</div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <CheckCircle className="w-5 h-5 text-orange-400" />
                <div>
                  <div className="font-semibold text-white">TECHNICIENS QUALIFIÉS</div>
                  <div className="text-xs">SPÉCIALISTES FICHET</div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Shield className="w-5 h-5 text-orange-400" />
                <div>
                  <div className="font-semibold text-white">DEVIS GRATUIT</div>
                  <div className="text-xs">ET TRANSPARENT</div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <Calendar className="w-5 h-5 text-orange-400" />
                <div>
                  <div className="font-semibold text-white">DISPONIBLE 7J/7</div>
                  <div className="text-xs">ET 24H/24</div>
                </div>
              </div>
            </div>
          )}

          {/* CTA Button */}
          {showCTA && config && (
            <a
              href={config.phone_link}
              onClick={() => { if(window.gtag_report_conversion) window.gtag_report_conversion(config.phone_link); }}
              className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-8 py-4 rounded-xl font-bold text-xl shadow-xl transition-all"
              data-testid="hero-cta-phone"
            >
              <Phone className="w-6 h-6" />
              <div>
                <div className="text-2xl">{config.phone}</div>
                <div className="text-xs font-normal opacity-90">APPELEZ-NOUS MAINTENANT</div>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
